import { Directive, inject, input, OnChanges, SimpleChanges } from '@angular/core';
import { TitleService } from '@miq/platform';
@Directive({ selector: '[miqTitle]' })
export class TitleDirective implements OnChanges {
  /**
   * Ideally has given title should match with any `value` of
   * `lookup/appcatalog` API
   */
  miqTitle = input<string>();
  private readonly titleService = inject(TitleService);
  ngOnChanges({ miqTitle }: SimpleChanges) {
    if (miqTitle && this.miqTitle()) {
      this.titleService.set(miqTitle.currentValue);
    } else {
      this.titleService.clear();
    }
  }
}
